import { ScrollArea } from '@mantine/core';
import { Panel } from 'react-resizable-panels';

const SidePanel = ({ children }: { children: React.ReactNode }) => {
    return (
        <Panel defaultSize={20} minSize={10}>
            <ScrollArea h="100%" scrollbars="y" type="hover">
                {children}
            </ScrollArea>
        </Panel>
    );
};

export default SidePanel;
